import { PrevButton, NextButton } from './SliderButton'

type SliderControlsProps = {
  onPrevClick: () => void
  onNextClick: () => void
  renderOnlyActiveControls?: boolean
  disableInactiveControls?: boolean
  navState: {
    prev: boolean
    next: boolean
  }
}

const SliderControls = ({
  onNextClick,
  onPrevClick,
  renderOnlyActiveControls = false,
  disableInactiveControls = false,
  navState,
}: SliderControlsProps) => {
  const shouldShowPrev = renderOnlyActiveControls ? navState.prev : true
  const shouldShowNext = renderOnlyActiveControls ? navState.next : true

  if (!shouldShowPrev && !shouldShowNext) {
    return null
  }

  return (
    <div className="slider-controls flex gap-6">
      {shouldShowPrev && (
        <PrevButton
          onClick={onPrevClick}
          isActive={navState.prev}
          disableWhenInactive={disableInactiveControls}
        />
      )}
      {shouldShowNext && (
        <NextButton
          onClick={onNextClick}
          isActive={navState.next}
          disableWhenInactive={disableInactiveControls}
        />
      )}
    </div>
  )
}

export default SliderControls
